import React, { Fragment } from "react"
import Select from "react-select"
import { Col, Label, Row } from "reactstrap"
import ReactDatePicker from "react-datepicker"
import { customStylesSelect } from "common/data/settings"

// Define a default UI for filtering
const CreateTeamFilter = props => {
  const {
    teamList,
    selectedMainCategory,
    categoryFilter,
    filtersubCategory,
    selectedSubcategory,
    subcategoryFilter,
    reportfilter,
    selectedReport,
    selectedUserData,
    userListFilter,
    startDate,
    setStartDate,
    handleTeamCancel,
    handlesubmit,
    companySetting,
    accessgroupId,
    filterUserData,
    supervisorfilter,
    selectedSupervisor,
    isDisable,
  } = props
  //Filter reportTo and User data Based on AccessGroupID
  const filterReport = teamList?.reportToLookup.filter(
    el => el.accessGroupid <= accessgroupId
  )
  const filterSupervisor = teamList?.teamSupervisorLookup.filter(
    el => el.accessGroupid >= accessgroupId
  )
  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }
  function SortReport(x, y) {
    if (x.userName < y.userName) {
      return -1
    }
    if (x.userName > y.userName) {
      return 1
    }
    return 0
  }
  const maincategory = teamList?.categoryLookup.sort(SortArray)
  const subCategory = filtersubCategory?.sort(SortArray)
  const reportTo = filterReport?.sort(SortReport)
  const userList = filterUserData?.sort(SortReport)

  const startDateChange = date => {
    setStartDate(date)
  }
  return (
    <Fragment>
      <Col md="12" className="mt-2 mb-2">
        <Row>
          <Col md="4">
            <div className="create_team_top">
              <Label htmlFor="formrow-state-Input">
                {companySetting.MainCategory}
              </Label>
              <Select
                value={selectedMainCategory}
                onChange={value => categoryFilter(value)}
                options={maincategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.id,
                }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_one"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="create_team_top">
              <Label htmlFor="formrow-state-Input">
                {companySetting.SubCategory}
              </Label>
              <Select
                isClearable
                value={selectedSubcategory}
                onChange={value => subcategoryFilter(value)}
                options={subCategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.name,
                }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_two"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="create_team_top">
              <Label htmlFor="formrow-state-Input">Report To</Label>
              <Select
                isClearable
                value={selectedReport}
                onChange={value => reportfilter(value)}
                options={reportTo
                  ?.filter(
                    value =>
                      value.accessGroupid !== 0 && value?.userName.trim() !== ""
                  )
                  .map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_three"
                styles={customStylesSelect}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Supervisor</Label>
              <Select
                isClearable
                value={selectedSupervisor}
                // isDisabled={isDisable}
                placeholder={
                  selectedSupervisor ? selectedSupervisor : "Select..."
                }
                onChange={value => supervisorfilter(value)}
                options={filterSupervisor?.map(el => ({
                  ...el,
                  label: el.userName,
                  value: el.userId,
                }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_three"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">User</Label>
              <Select
                isMulti
                isClearable
                value={selectedUserData}
                closeMenuOnSelect={false}
                onChange={value => userListFilter(value)}
                options={userList
                  ?.filter(value => value?.userName.trim() !== "")
                  .map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                classNamePrefix="select2-selection"
                className="add_Zindex_four"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          <Col md="4">
            <div className="mt-2">
              <Label htmlFor="formrow-state-Input">Start Date</Label>
              <ReactDatePicker
                wrapperClassName="datePicker"
                dateFormat="yyyy-MM-dd"
                selected={startDate}
                onChange={startDateChange}
                className="form-control mb-0 date-icon-back cursor-pointer "
                placeholderText="Select date"
                // minDate={new Date()}
              />
            </div>
          </Col>

          <div className="mt-4 d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary save-customer me-2"
              onClick={handlesubmit}
            >
              Save
            </button>
            <button
              type="button"
              color="primary"
              className="btn btn-secondary"
              onClick={handleTeamCancel}
            >
              Cancel
            </button>
          </div>
        </Row>
      </Col>
    </Fragment>
  )
}

export default CreateTeamFilter
